import { points as en_points } from "../en/points";

/** points — ES slice. */
export const points: Record<keyof typeof en_points, string> = {
  points_launcher_tab_open_button: "Puntos y recompensas",

  // My Points (home)
  points_home_balance_label: "Puntos",
  points_home_stat_this_week: "Esta semana",
  points_home_stat_this_month: "Este mes",
  points_home_stat_all_time: "Histórico",
  points_home_stat_redeemed: "Canjeados",
  points_home_recent_activity_title: "Actividad reciente",
  points_home_recent_activity_empty: "Aún no hay actividad",
  points_home_see_all_button: "Ver todo →",

  // Navigation rows
  points_nav_rewards: "Tienda de recompensas",
  points_nav_achievements: "Logros",
  points_nav_history: "Historial de puntos",
  points_nav_invite: "Invita y gana",

  // Relative time
  points_time_just_now: "justo ahora",
  points_time_minutes_ago: "hace {count}min",
  points_time_hours_ago: "hace {count}h",
  points_time_days_ago: "hace {count}d",

  // Ledger source labels
  points_source_profile_completion: "Perfil completado",
  points_source_daily_login: "Registro diario",
  points_source_referral: "Bono por referido",
  points_source_card_exchange: "Tarjeta intercambiada",
  points_source_experience_confirmation: "Encuentro confirmado",
  points_source_achievement: "Logro desbloqueado",
  points_source_founding_member: "Miembro fundador",
  points_source_event_check_in: "Registro en evento",
  points_source_tap_connect: "Toca para conectar",
  points_source_qr_swap: "Intercambio por QR",
  points_source_social_share: "Compartido en redes",
  points_source_invite_new_user: "Amigo se unió",
  points_source_mini_game: "Minijuego",
  points_source_photo_challenge: "Reto de fotos",
  points_source_leaderboard: "Clasificación",
  points_source_reward_redemption: "Recompensa canjeada",
  points_source_admin_adjustment: "Ajuste",

  // Rewards Store
  points_rewards_category_badges: "Insignias",
  points_rewards_category_perks: "Beneficios",
  points_rewards_category_merch: "Merchandising",
  points_rewards_category_events: "Eventos",
  points_rewards_category_partner: "Beneficios de socios",
  points_rewards_coming_soon_tag: "Próximamente",
  points_rewards_filter_all: "Todo",
  points_rewards_empty: "Aún no hay recompensas en esta categoría",
  points_rewards_state_coming_soon: "🔒 Próximamente",
  points_rewards_state_owned: "✅ Obtenida",
  points_rewards_redeem_button: "Canjear",
  points_rewards_need_more: "Te faltan {count}",
  points_rewards_redeem_dialog_title: "¿Canjear {name}?",
  points_rewards_redeem_dialog_description:
    "Esto descontará {cost} Puntos y la añadirá a tu cuenta. Las insignias son permanentes.",
  points_rewards_redeem_cancel: "Cancelar",
  points_rewards_redeeming: "Canjeando…",
  points_rewards_redeem_confirm: "Confirmar · {cost}",

  // Rewards Store — badges help
  points_rewards_badges_help_aria: "Cómo conseguir insignias",
  points_rewards_badges_help_title: "Cómo conseguir insignias",
  points_rewards_badges_help_intro:
    "Las insignias son permanentes y aparecen en tu Linq Card. Canjéalas con Puntos. Gana Puntos con el registro diario, completando tu perfil, haciendo conexiones, asistiendo a eventos e invitando a amigos.",
  points_rewards_badges_help_how: "Canjea por {cost} Puntos",
  points_rewards_badges_help_coming_soon: "Próximamente",
  points_rewards_badges_help_granted:
    "Algunas insignias, como Miembro Fundador, se otorgan automáticamente y no se pueden comprar.",
  points_rewards_badges_help_close: "Entendido",

  // Achievements
  points_achievements_unlocked_count: "{unlocked} / {total} desbloqueados",
  points_achievements_milestones_title: "Hitos",
  points_achievements_badges_title: "Tus insignias",
  points_achievements_badges_get: "Obtener",
  points_achievements_badges_empty:
    "Aún no tienes insignias — canjea una en la Tienda de recompensas.",
  points_achievements_first_connection: "Haz tu primera conexión",
  points_achievements_reach_connections: "Alcanza {count} conexiones",
  points_achievements_attend_events: "Asiste a {count} eventos",
  points_achievements_unlocks_with_events: "Se desbloquea con Eventos",

  // Points History
  points_history_filter_all: "Todo",
  points_history_filter_earned: "Ganados",
  points_history_filter_spent: "Gastados",
  points_history_day_today: "Hoy",
  points_history_day_yesterday: "Ayer",
  points_history_empty: "Todavía no hay nada aquí.",
  points_history_redeemed_badge: "Canjeado",
  points_history_loading_more: "Cargando…",
  points_history_load_more: "Cargar más",

  // Invite & Earn
  points_invite_hero_title: "Invita a tus amigos y gana Puntos",
  points_invite_hero_description:
    "Gana +{count} Puntos cada vez que un amigo se una con tu enlace y termine de configurar su cuenta.",
  points_invite_link_label: "Tu enlace de invitación",
  points_invite_copied: "¡Copiado!",
  points_invite_copy: "Copiar",
  points_invite_share_button: "Compartir enlace de invitación",
  points_invite_share_title: "Únete a mí en Linqx",
  points_invite_how_it_works_title: "Cómo funciona",
  points_invite_step_share: "Comparte tu enlace",
  points_invite_step_friend_opens: "Tu amigo lo abre y se registra",
  points_invite_step_onboarding: "Completa la configuración",
  points_invite_step_reward: "Ganas +{count} Puntos",
  points_invite_footer_note: "Los créditos aparecen en el Historial de puntos",
};
